import * as React from 'react';

import { ListItemUnreadBadge } from '../../ListItem/styles';

interface UnreadBadgeProps {
	isUnread: boolean;
}

const UnreadBadge = ({ isUnread }: UnreadBadgeProps) => {
	if (!isUnread) {
		return null;
	}

	return <ListItemUnreadBadge />;
};

export default UnreadBadge;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CoverFlow/UnreadBadge/index.tsx